import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import GlobalStyles from './components/styles/GlobalStyle';
import Typography from './components/styles/Typography';

import "./i18n";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <>
    <GlobalStyles />
    <Typography />
    <App />
    </>
);